import React from 'react';
import classnames from 'classnames';
import {
  withMobileContext,
  WithMobileContextProps,
} from '@wix/da-react-context/pkg/MobileContext';
import Checkbox from '@wix/da-ds/pkg/Checkbox';
import s from './IntentCard.scss';

export interface IntentCardProps {
  id: string;
  title: string;
  iconSrc: string;
  description: string;
  selected: boolean;
  collapsed?: boolean;
  disableHoverStyles?: boolean;
  className?: string;
  onClick(id: string): void;
}

class IntentCard extends React.Component<
  IntentCardProps & WithMobileContextProps
> {
  state = {
    mouseOver: false,
    // this is to make unselecting more visually informative
    // cause hovering effect is pretty intense
    // so it is disabled after unselecting
    // until the mouse enters the block again
    afterUnselectedBeforeMouseLeft: false,
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.mouseOver && this.props.selected && !nextProps.selected) {
      this.setState({ afterUnselectedBeforeMouseLeft: true });
    }
  }

  render() {
    const {
      id,
      title,
      description,
      iconSrc,
      selected,
      collapsed,
      disableHoverStyles,
      className,
    } = this.props;
    const state = this.state;
    const titleId = `${id}_title`;
    const descId = `${id}_desc`;

    return (
      <button
        type="button"
        role="gridcell"
        aria-selected={selected ? 'true' : 'false'}
        aria-labelledby={titleId}
        aria-describedby={descId}
        className={classnames(
          s['intent-card'],
          s[`intent-card-${id}`],
          s['topics-onboarding'],
          selected && s['selected'],
          collapsed && s['collapsed'],
          disableHoverStyles && s['disable-hover'],
          state.afterUnselectedBeforeMouseLeft &&
            s['after-unselected-before-mouse-left'],
          className
        )}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
        onClick={this.onClick}
      >
        <div className={s.corner}>{this.renderCornermark()}</div>
        <div className={s.content}>
          <div className={s.icon}>
            <img src={iconSrc} alt={title} />
          </div>
          <div id={titleId} className={s.title}>
            {title}
          </div>
          <div id={descId} className={s.description}>
            {description}
          </div>
        </div>
      </button>
    );
  }

  renderCornermark() {
    return (
      <Checkbox className={s['corner-mark']} isChecked={this.props.selected} />
    );
  }

  onMouseEnter = () => {
    this.setState({ mouseOver: true });
  };
  onMouseLeave = () => {
    this.setState({ mouseOver: false, afterUnselectedBeforeMouseLeft: false });
  };
  onClick = () => {
    this.props.onClick(this.props.id);
  };
}

export default withMobileContext(IntentCard);
